import React, {Component} from 'react';
import config from "../config";
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles, title} from "../website-utils/meta";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";

import ProHeader from '../parts/ProHeader';
import Footer from '../parts/Footer';

import logoWhite from '../assets/images/logo-white.png';
import phonePros from '../assets/images/phone-pros.png';
import iconTime from '../assets/images/icon-time.png';
import iconGrowNetwork from '../assets/images/icon-grow-network.png';
import iconMoneyPhone from '../assets/images/icon-money-phone.png';
import iconSpatulaKnife from '../assets/images/icon-spatula-knife.png';
import iconWallet from '../assets/images/icon-wallet.png';
import iconBuildReputation from '../assets/images/icon-build-reputation.png';
import heroBackgroundImage from '../assets/images/background-home-hero.jpg';


class ProHomePage extends Component {
  componentDidMount() {
    window.analytics.page("Pros", "Home");
  }

  render() {
    window.prerenderReady = true;

    return (
      <div className="pros home">
        <Helmet>
          {title('SingleShift - Pros')}
          {metaTitles('SingleShift - Pros')}
          {metaDescriptions('Earn money picking up shifts at restaurants and events, right from your phone.')}
          {metaImages(`${window.location.origin}${heroBackgroundImage}`)}
        </Helmet>
        <ScrollToTopOnMount/>

        {/* Hero */}
        <div className="hero bottom-slant" style={{backgroundImage: `url(${heroBackgroundImage})`}}>
          <div className="container">
            <ProHeader/>
            <div className="row flex-md-row-reverse align-items-center">
              <div className="col-md-6 headline">
                <h1>Work when you want, earn what you need.</h1>
                <p>Earn money picking up shifts for food and beverage businesses.</p>
                <Link to={config.routes.prosSignUp}>
                  <button type="button" className="btn btn-primary btn-xlg btn-pointer">Get Started</button>
                </Link>
              </div>
              <div className="col-md-6 text-center iphone">
                <img className="img-fluid" src={phonePros}/>
              </div>
            </div>
          </div>
        </div>

        {/* Value Props */}
        <div className="container">
          <div className="value_props">

            <div className="row justify-content-md-center">
              <div className="col-md-12">
                <h2 className="text-center">Why work on SingleShift?</h2>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-2">
                    <img src={iconTime}/>
                  </div>
                  <div className="col-10 value">
                    <h4>Flexibility</h4>
                    <p className="text-demphasis">Work as much or as little as you want. Pick up only the gigs you want to
                      work. It's completely up to you.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-2">
                    <img src={iconGrowNetwork}/>
                  </div>
                  <div className="col-10 value">
                    <h4>Grow your network</h4>
                    <p className="text-demphasis">Meet and connect with people in the industry who can help you develop
                      and expand your career.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-2">
                    <img src={iconMoneyPhone}/>
                  </div>
                  <div className="col-10 value">
                    <h4>Convenience</h4>
                    <p className="text-demphasis">We bring the gigs to you. Review offers, track earnings, manage your
                      schedule all in our smartphone app.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-2">
                    <img src={iconBuildReputation}/>
                  </div>
                  <div className="col-10 value">
                    <h4>Build your reputation</h4>
                    <p className="text-demphasis">Prove yourself by earning positive ratings and reviews from your gigs at
                      a variety of restaurants.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-2">
                    <img src={iconSpatulaKnife}/>
                  </div>
                  <div className="col-10 value">
                    <h4>Learn new skills</h4>
                    <p className="text-demphasis">Gain a broad range of experiences in different cuisines and techniques
                      at different venues with new chefs.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-2">
                    <img src={iconWallet}/>
                  </div>
                  <div className="col-10 value">
                    <h4>Get paid weekly</h4>
                    <p className="text-demphasis">See your earnings show up in your bank account or on your debit card
                      every week.</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <Footer/>

      </div>
    );
  }
}

export default ProHomePage;



// WEBPACK FOOTER //
// ./src/pages/ProHomePage.js